import { http } from "../http-common";

const getProfileList = (page, size) => {
  return http.get(
    `/profile/list?pageNumber=${page}&size=${size}`
  );
};

const getFuntionalityOptions = () => {
  return http.get(`/functionalities`);
};

const createProfileRegistration = (data) => {
  return http.post("/profile", data);
};

const updateProfileRegistration = (data) => {
  return http.put(`/profile`, data);
};

const getProfilesSearchQuery = (query,page, size) => {
  return http.get(
    `/profile/find?profileCode=${query}&profileName=${query}&pageNumber=${page}&size=${size}`
  );
};

const ProfileService = {
  getProfileList,
  getFuntionalityOptions,
  createProfileRegistration,
  updateProfileRegistration,
  getProfilesSearchQuery,
};

export default ProfileService;
